import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { ExternalLink } from "~/atoms/ExternalLink";
import { colors } from "~/utils/colors";
import { breakPoints } from "~/utils/variables";
import { useLocation } from "@reach/router";

type Props = {
  isTopPage?: Boolean;
};

export const LpRop01PageFooter: React.FC<Props> = ({ isTopPage = false }) => {
  const { logo } = useStaticQuery<GatsbyTypes.LpRop01PageFooterLogoQuery>(graphql`
    query LpRop01PageFooterLogo {
      logo: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          gatsbyImageData(width: 120, quality: 100, placeholder: NONE, layout: CONSTRAINED)
        }
      }
    }
  `);
  const location = useLocation();

  return (
    <>
      <footer className="container">
        <div className="logo">
          {logo?.childImageSharp && (
            <Link to={`/lp/rpo/01${location.search}`}>
              <GatsbyImage image={logo?.childImageSharp?.gatsbyImageData} alt="refcome" />
            </Link>
          )}
        </div>
        <div className="navigationList">
          <div className="navigationListItem">
            <ExternalLink to="https://willof-partner.co.jp/company" target="_blank">
              会社概要
            </ExternalLink>
          </div>
          <div className="navigationListItem">
            <Link to="https://refcome.team/terms" target="_blank">
              利用規約
            </Link>
          </div>
          <div className="navigationListItem">
            <Link to="https://jp.refcome.com/privacy" target="_blank">
              個人情報の取り扱い
            </Link>
          </div>
          <div className="navigationListItem">
            <Link to="https://jp.refcome.com/privacy/statement" target="_blank">
              個人情報保護方針
            </Link>
          </div>
        </div>
        <div className="copyright">
          <small className="copyrightText">Copyright © WILLOF PARTNER, Inc. All rights reserved.</small>
        </div>
      </footer>

      <style jsx>{`
        .container {
          background-color: ${(isTopPage && colors.lightGray) || colors.white};
          color: ${colors.defaultText};
          padding: 60px 30px 30px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        .logo {
          display: block;
          height: 32px;
          width: 120px;
        }
        .navigationList {
          display: flex;
          margin-top: 24px;
          list-style: none;
          gap: 40px;
        }
        .navigationListItem {
          font-size: 12px;
          margin-top: 5px;
        }
        .navigationListItem :global(a),
        .navigationListItem :global(a:visited),
        .navigationListItem :global(a:active) {
          color: ${colors.defaultText};
        }
        .navigationListItem :global(a:hover) {
          text-decoration: underline;
        }
        .navigationListItem :global(a .en) {
          font-size: 1.16em;
        }
        .copyright {
          display: flex;
          justify-content: center;
          margin-top: 24px;
        }
        .copyrightText {
          font-size: 11px;
          text-align: center;
          line-height: 1;
        }

        @media (${breakPoints.sp}) {
          .container {
            padding: 40px 20px 20px;
          }
          .navigationList {
            flex-wrap: wrap;
            gap: 10px;
            justify-content: center;
            align-items: center;
            width: 100%;
          }
          .navigationList div {
            width: calc(50% - 10px);
          }
          .navigationListItem {
            text-align: center;
            font-size: 14px;
          }
        }
      `}</style>
    </>
  );
};
